// extracted by css-extract-rspack-plugin
export default {"textInputContainer":"textInputContainer-2MTD2"};